import React from "react";
import { money } from "utils/helpers";
import LogoView from "components/DataDisplay/LogoView";
import { getOfferTerms } from "../helpers";

const LenderRow = ({ offer, isSelected, cartTotal, onSelect, promo }) => {
  const approved = parseFloat(offer.approved_amount || 0);
  const delta = approved - cartTotal;
  const isUnder = delta >= 0;
  const { leaseType, frequency } = getOfferTerms(offer, cartTotal);
  const terms = [leaseType, frequency].filter(Boolean).join(" · ");

  return (
    <li className={"lender-row" + (isSelected ? " lender-row--selected" : "")}>
      <span className="lender-row__logo">
        <LogoView provider={offer.specific_provider_name} />
      </span>

      <div className="lender-row__body">
        <div className="lender-row__amount">
          ${money(approved)}
          <span className="lender-row__amount-sub">approved</span>
        </div>
        {terms && <div className="lender-row__terms">{terms}</div>}
        <div className="lender-row__metrics">
          <span
            className={
              "lender-row__delta " +
              (isUnder ? "lender-row__delta--under" : "lender-row__delta--over")
            }
          >
            {isUnder
              ? `$${money(delta)} under`
              : `$${money(Math.abs(delta))} short`}
          </span>
          {promo && (
            <span className="lender-row__promo">${promo} offer available</span>
          )}
        </div>
      </div>

      <div className="lender-row__action">
        {isSelected ? (
          <span className="lender-row__selected">Selected</span>
        ) : (
          <button
            type="button"
            className="lender-row__select-btn"
            onClick={() => onSelect(offer.specific_provider_name)}
          >
            Select
          </button>
        )}
      </div>
    </li>
  );
};

export default LenderRow;
